// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__33MAi","requiredAsterisk":"Info_requiredAsterisk__1rlQZ"};